<wbo-edit-grid [data]="model.data[fieldName]" [editable]="true" [entityPath]="fieldName" [removable]="true" [title]="'wbo.report.surcharge-selection.title'">
    <wbo-text-column field="name" [title]="'wbo.report.surcharge-selection.column.name'"></wbo-text-column>
    <wbo-edit-grid-add-row [customAdd]="true">
        <wbo-edit-grid-add-row-quick-add (onSelect)="addFromSurcharge([$event])">
            <wbo-surcharge-single-select-edit-control></wbo-surcharge-single-select-edit-control>
        </wbo-edit-grid-add-row-quick-add>
        <wbo-edit-grid-add-row-actions>
            <wbo-edit-grid-add-row-search (onSelect)="addFromSurcharge($event)" [searchComponent]="SurchargeSearchPageComponent"></wbo-edit-grid-add-row-search>
        </wbo-edit-grid-add-row-actions>
    </wbo-edit-grid-add-row>
</wbo-edit-grid>
